import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApiContext, BACKEND_CONFIG } from '@unicup-ticketing/injection-context';
import { Observable } from 'rxjs';
import { InvitationTokenResponse } from './invitation-token.service';
import { HasLinks } from '@unicup-ticketing/utils';

export interface InvitationTokenApiResponse extends InvitationTokenResponse, HasLinks {}

@Injectable({
  providedIn: 'root',
})
export class InvitationTokenApi {
  private readonly backendBaseUrl: string;

  private readonly http = inject(HttpClient);

  constructor() {
    const backendConfig = inject<ApiContext>(BACKEND_CONFIG);

    this.backendBaseUrl = backendConfig.baseUrl;
  }

  public createToken(drawId: string, registrationId: string): Observable<InvitationTokenApiResponse> {
    return this.http.post<InvitationTokenApiResponse>(
      `${this.backendBaseUrl}/draws/${drawId}/registrations/${registrationId}/invite`,
      {},
    );
  }

  public redeemToken(drawId: string, value: string): Observable<HttpResponse<void>> {
    return this.http.post<void>(
      `${this.backendBaseUrl}/draws/${drawId}/tokens/redeem`,
      { value },
      { observe: 'response' },
    );
  }

  public answerOnMembershipRequest(drawId: string, tokenId: string, choice: boolean): Observable<HttpResponse<void>> {
    return this.http.post<void>(
      `${this.backendBaseUrl}/draws/${drawId}/tokens/${tokenId}`,
      { isAllowed: choice },
      { observe: 'response' },
    );
  }
}
